import styled, { css } from "styled-components";
import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";

const isBetto = window.TENANT === "betto";

const BonusItemWrapper = styled.div`
	display: flex;
	padding: 5px 0px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
	border-radius: ${isBetto ? "12px" : "15px"};
	background: var(--input-bg-has-value);
	margin-bottom: 10px;
	width: 100%;

	${isBetto &&
	css`
		overflow: hidden;
		border: 1px solid ${BTTO_PROFILE_COLORS.border};
	`}
`;

const ItemHeader = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	background: var(--main-explosive-gradient-020);
	color: #f7f7fc;
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;
	border-radius: 15px 15px 0px 0px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 14px;
	}
`;

const DetailWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	justify-content: center;
`;

const DateWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 10px;
	justify-content: center;
	align-self: stretch;
	width: 100%;
`;

const Date = styled.div`
	align-items: center;
	display: flex;
	flex: 1 0 0;
	color: #a0a3bd;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	border-top: 1px solid var(--header-color);
	padding-top: 5px;
	cursor: pointer;

	svg {
		width: 14px;
		height: 14px;
		path {
			stroke: var(--header-color);
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: var(--header-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const Detail = styled.div`
	display: flex;
	padding: 10px;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	color: var(--main-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
	}
`;
const ItemContent = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	background: var(--main-explosive-gradient-020);
	height: 60px;
`;

const ContentInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #f7f7fc;
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
	}
`;

const InfoTitle = styled.div`
	color: #f7f7fc;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

const Info = styled.div`
	color: #f7f7fc;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.3px;
	padding-left: 3px;

	@media (min-width: 768px) {
		font-size: 16px;
	}
`;

const ContentButton = styled.div`
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	border-radius: 20px;
	background: var(--main-gradient);
	display: flex;
	height: 30px;
	padding: 0 15px 0 10px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	cursor: pointer;

	${({ disableButton }) =>
		disableButton &&
		css`
			pointer-events: none;
		`}
`;

const FSItemContentWrapper = styled.div`
	display: flex;
	padding: 5px 10px;
	align-items: center;
	gap: 15px;
	flex: 1 0 0;
	width: 100%;
	background: var(--main-explosive-gradient-020);
`;

const FSContentTitle = styled.div`
	display: flex;
	align-items: center;
	color: #f7f7fc;
	letter-spacing: 0.3px;
	line-height: 20px;
	gap: 3px;

	span {
		display: flex;
		&:first-of-type {
			font-size: 14px;
			font-weight: 700;
		}

		&:last-of-type {
			font-size: 12px;
			font-weight: 600;
		}
	}
`;

const FSContentButton = styled.div`
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	display: flex;
	height: 30px;
	padding: 0 15px 0 10px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 20px;
	background: linear-gradient(180deg, var(--main-color-light) 0%, var(--main-color-dark) 100%);
	cursor: pointer;

	${({ disableButton }) =>
		disableButton &&
		css`
			pointer-events: none;
		`}
`;

const FSItemContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 5px;
`;

const FSItemImg = styled.img`
	width: 110px;
	height: 80px;
	border-radius: 20px;
	max-width: 110px;
`;

export {
	BonusItemWrapper,
	ButtonText,
	ContentButton,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	FSContentButton,
	FSContentTitle,
	FSItemContent,
	FSItemContentWrapper,
	FSItemImg,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
};
